import { ChangeDetectionStrategy, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { BreadcrumbNavigationService, ConfigurationService, CoursesService, RestApiService } from '@draeger-academy/common';
import { CartService } from '@draeger-academy/common/lib/services/cart/cart.service';
import { GenericModalService } from '@draeger-academy/presentation/lib/modules/generic-modal';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Course } from '../../../../../../models/course';
import { Training } from '../../../../../../models/training';
import { TrainingDescription } from '../../../../../../models/training-description';
import { Paragraph } from '../../../../../../models/paragraph';

declare var require: any;
import { HttpClient } from '@angular/common/http';
import { CartItem } from 'models/cartItem';
@Component({
    selector: 'da-course-detail',
    templateUrl: './course-detail.component.html',
    styleUrls: ['./course-detail.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CourseDetailComponent implements OnInit {
    public currency = '';
    public format = '';
    public languageCode = '';
    public site: string;
    public description: any;
    private _subscription: Subscription;
    private _courseSub: Subscription;
    private _modalId: string;
    private _$course: BehaviorSubject<Course> = new BehaviorSubject<Course>(null);
    private _$similarCourses: BehaviorSubject<Course[]> = new BehaviorSubject<Course[]>(null);
    private _$isString: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
    private _$tabSection: BehaviorSubject<object> = new BehaviorSubject(null);
    private _$showDownload: BehaviorSubject<boolean> = new BehaviorSubject(false);
    private _$currencyPositionBefore: BehaviorSubject<string> = new BehaviorSubject('');
    private _$showCartUpdate: BehaviorSubject<boolean> = new BehaviorSubject(false);
    private _$showSimilarCourses: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public downloadDescriptionLink: string;
    public courseImage;
    public logo = '';
    public learningGoals: string;
    public eventsNorth: Array<CartItem>;
    public eventsEast: Array<CartItem>;
    public eventsSouth: Array<CartItem>;
    public eventsWest: Array<CartItem>;
    public citiesNorth: Array<string>;
    public citiesEast: Array<string>;
    public citiesSouth: Array<string>;
    public citiesWest: Array<string>;
    public eventDuration: number;
    public courseUrl: string;
    public courseUrlPrint: string;
    public qrCodeDownloadLink = '';
    public learningGoalsText: Array<Paragraph>;
    public targetGroupText: Array<Paragraph>;
    public courseContentText: Array<Paragraph>;
    public noteText: Array<Paragraph>;
    public requirementsText: Array<Paragraph>;
    public training: Training;
    public trainingDescriptions: Array<TrainingDescription>;
    public paragraph: Array<Paragraph>;
    public events: Array<CartItem>;
    public portalCountry: string;

    @ViewChild('pdfCourse')
    pdfCourse: ElementRef;

    private _$courseImage: BehaviorSubject<{}> = new BehaviorSubject<{}>(null);
    public get courseImage$(): Observable<{}> {
        return this._$courseImage.asObservable();
    }

    constructor(
        private sanitizer: DomSanitizer,
        private route: ActivatedRoute,
        private _coursesService: CoursesService,
        private _restApiService: RestApiService,
        private _breadcrumbNavigationService: BreadcrumbNavigationService,
        private _configurationService: ConfigurationService,
        private _cartService: CartService,
        private _genericModalService: GenericModalService,
        private _translateService: TranslateService,
        private http: HttpClient
    ) {}

    public get showCartUpdate$(): Observable<boolean> {
        return this._$showCartUpdate.asObservable();
    }

    public get currencyPositionBefore$(): Observable<string> {
        return this._$currencyPositionBefore.asObservable();
    }

    public get course$(): Observable<Course> {
        return this._$course.asObservable();
    }

    public get similarCourse$(): Observable<Course[]> {
        return this._$similarCourses.asObservable();
    }

    public get isString$(): Observable<boolean> {
        return this._$isString.asObservable();
    }

    public get showDownload$(): Observable<boolean> {
        return this._$showDownload.asObservable();
    }

    public get tabSection$(): Observable<object> {
        return this._$tabSection.asObservable();
    }

    public get showSimilarCourses$(): Observable<boolean> {
        return this._$showSimilarCourses.asObservable();
    }

    private _$showVat: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public get showVat$(): Observable<boolean> {
        return this._$showVat.asObservable();
    }

    onChangeURL(url) {
        this.qrCodeDownloadLink = url;
    }

    ngOnInit(): void {
        this.courseUrl = window.location.href;
        this.courseUrlPrint = this.courseUrl.replace('https://', '');
        this.courseUrlPrint = this.courseUrlPrint.replace('http://', '');
        this.logo = environment.locales + 'assets/images/logo.svg';
        this._breadcrumbNavigationService.setInitialCourseBreadcrumb();
        this.getCourse();
        this._courseSub = this.course$.subscribe((course) => {
            if (course && this._subscription) {
                this._coursesService.getNumberOfCourses().then((numberOfCourses) => {
                    this._breadcrumbNavigationService.updateCourseBreadcrumb(course, numberOfCourses.count);
                });
                if (course.image && course.image.uri) {
                    let courseImage = environment.APIEndpoint + course.image.uri.substr(course.image.uri.indexOf('/') + 1);
                    courseImage = encodeURI(courseImage);
                    this.courseImage = courseImage;
                    this._$courseImage.next(courseImage);
                    // this.imageUrlToBase64(courseImage).subscribe((base64) => {
                    //     courseImage = base64;
                    //     this._$courseImage.next(courseImage);
                    // });
                }
                try {
                    const desc = JSON.parse(course.training.description);
                    this._$isString.next(false);
                    this.description = desc;
                } catch {
                    if (course.training && course.training.description && typeof course.training.description === 'string') {
                        this._$isString.next(true);
                        this.description = course.training.description;
                    }
                }
                this.events = this._$course.getValue().events;
                const events = this._$course.getValue().events;
                this.eventsFilteredByCostcenter(events);
                this.createEventDaysandTimes(events);
            }
            if (course) {
                this.currency = this._configurationService.loadCurrenciesConfigurations(course.prices[0].currency);
            }
        });

        this._restApiService.requestGET<any>('/assets/mock/tabsection_data.json').then((data: any) => {
            this._$tabSection.next(data);
        });

        this._$showDownload.next(this._configurationService.hasFeature('DownloadCourseDescription'));
        this._$showSimilarCourses.next(this._configurationService.hasFeature('ShowSimilarCourses'));

        if (this._configurationService.isPartnerPage()) {
            this._translateService.stream('common').subscribe((translation) => {
                this._$currencyPositionBefore.next(translation.currencyBeforePrice);
            });
        } else {
            this._configurationService.$siteSettings.subscribe((data) => {
                if (data && data.length > 0) {
                    this._$currencyPositionBefore.next(data.filter((f) => f.key.toLowerCase() === 'currency')[0].currencyBeforePrice);
                    this.format = data.filter((f) => f.key.toLowerCase() === 'currency')[0].format
                        ? data.filter((f) => f.key.toLowerCase() === 'currency')[0].format
                        : '';
                    this.languageCode = data.filter((f) => f.key.toLowerCase() === 'currency')[0].language
                        ? data.filter((f) => f.key.toLowerCase() === 'currency')[0].language
                        : '';
                }
            });
        }
    }

    // ngOnDestroy() {
    //     this._subscription.unsubscribe();
    //     this._courseSub.unsubscribe();
    //     localStorage.setItem('scrolly', window.pageYOffset.toString());
    // }

    getCourse() {
        this._subscription = this.route.params.subscribe((param) => {
            const _courseId = param['id'];
            const _site = this._configurationService.getCurrentSite();
            this.site = _site;

            let params = '';
            if (this._configurationService.isPartnerPage()) {
                this._configurationService.currentPortal$.subscribe((portalId) => {
                    if (portalId) {
                        const temp = portalId.toLocaleUpperCase().replace('-', '_').replace('-', '_');
                        params = `?portalName=${temp}`;
                    }
                });
                this._configurationService.getConfigPartnerByPortal().then((data) => {
                    this.portalCountry = data.filter((f) => f.key.toLowerCase() === 'countries')[0].value[0].code.toLowerCase();
                    this._coursesService.getPortalCourseById(_courseId, this.portalCountry).then(
                        (course) => {
                            if (course) {
                                this._$course.next(course);
                                if (this.route.queryParams) {
                                    this._subscription = this.route.queryParams.subscribe((parameter) => {
                                        const isDates = Boolean(parameter['dates']) ? true : false;
                                        if (isDates) {
                                            setTimeout(() => {
                                                const tabSecond = <HTMLElement>(
                                                    document.querySelector('.tab-section .tabs-wrapper .tabs li:last-of-type')
                                                );
                                                tabSecond.click();
                                                setTimeout(() => {
                                                    window.scrollTo(0, Number(localStorage.getItem('scrolly')));
                                                }, 100);
                                            }, 100);
                                        }
                                    });
                                }
                            }
                        },
                        (error) => {
                            console.log(error);
                        }
                    );
                });
            } else {
                params = `?countryCode=${_site}`;
                this._coursesService.getCourseById(_courseId).then(
                    (course) => {
                        if (course) {
                            this._$course.next(course);
                            this.findDescriptionParagraphs();
                            if (this._configurationService.hasFeature('ShowSimilarCourses')) {
                                this._coursesService.getSimilarCourses(course.id).then((data) => {
                                    if (data) {
                                        this._$similarCourses.next(data);
                                    }
                                });
                            }

                            if (this.route.queryParams) {
                                this._subscription = this.route.queryParams.subscribe((parameter) => {
                                    const isDates = Boolean(parameter['dates']) ? true : false;
                                    if (isDates) {
                                        setTimeout(() => {
                                            const tabSecond = <HTMLElement>(
                                                document.querySelector('.tab-section .tabs-wrapper .tabs li:last-of-type')
                                            );
                                            tabSecond.click();

                                            setTimeout(() => {
                                                window.scrollTo(0, Number(localStorage.getItem('scrolly')));
                                            }, 100);
                                        }, 100);
                                    }
                                });
                            }
                        }
                    },
                    (error) => {
                        console.log(error);
                    }
                );
            }
            this.downloadDescriptionLink = `${environment.APIEndpoint}api/v1/course/getcoursedescription/${_courseId}${params}`;
        });
    }

    public goToCart() {
        this._$showCartUpdate.next(false);
        this.closeModal();
        this._cartService.goToCart();
    }

    public closeModal() {
        if (this._modalId) {
            this._genericModalService.close(this._modalId);
        }
    }

    public printPDFCourse() {
        window.print();
    }

    eventsFilteredByCostcenter(events) {
        this.eventsNorth = [];
        this.eventsEast = [];
        this.eventsSouth = [];
        this.eventsWest = [];
        events.forEach((element: CartItem) => {
            if (element.costCenterCode === 'TC-DEN' || element.costCenterCode === 'AC-SD') {
                this.eventsNorth.push(element);
            } else if (element.costCenterCode === 'TC-DEO') {
                this.eventsEast.push(element);
            } else if (element.costCenterCode === 'TC-DES') {
                this.eventsSouth.push(element);
            } else if (element.costCenterCode === 'TC-DEW') {
                this.eventsWest.push(element);
            }
        });
        this.citiesNorth = this.listForCities(this.eventsNorth);
        this.citiesEast = this.listForCities(this.eventsEast);
        this.citiesSouth = this.listForCities(this.eventsSouth);
        this.citiesWest = this.listForCities(this.eventsWest);
    }

    listForCities(events) {
        const cities: Array<string> = [];
        events.forEach((element: CartItem) => {
            if (cities.indexOf(element.location.city) === -1) {
                cities.push(element.location.city);
            }
        });
        return cities;
    }

    createEventDaysandTimes(events) {
        if (events && events.length > 0) {
            const event = events[0];
            const d1 = new Date(event.endDateTime);
            const d2 = new Date(event.beginDateTime);
            this.eventDuration = this.daysDiff(d2, d1);
        }
    }

    public secondsDiff(d1, d2) {
        const secDiff = Math.floor((d2 - d1) / 1000);
        return secDiff;
    }

    public minutesDiff(d1, d2) {
        const seconds = this.secondsDiff(d1, d2);
        const minutesDiff = Math.floor(seconds / 60);
        return minutesDiff;
    }

    public hoursDiff(d1, d2) {
        const minutes = this.minutesDiff(d1, d2);
        const hoursDiff = Math.floor(minutes / 60);
        return hoursDiff;
    }

    public daysDiff(d1, d2) {
        const hours = this.hoursDiff(d1, d2);
        const daysDiff = Math.ceil(hours / 24);
        return daysDiff;
    }

    public findDescriptionParagraphs() {
        this.training = this._$course.getValue().training;
        this.trainingDescriptions = this.training.trainingDescriptions;
        if (this.trainingDescriptions) {
            this.trainingDescriptions.forEach((desc: TrainingDescription) => {
                if (desc.name === 'INHALT' && desc.paragraphs.length > 1) {
                    for (let i = 1; i <= desc.paragraphs.length - 1; i++) {
                        const paragraph = desc.paragraphs[i];
                        if (paragraph.subTexts === null) {
                            desc.paragraphs.splice(desc.paragraphs.indexOf(paragraph), 1);
                        }
                    }
                }
            });
            this.trainingDescriptions.forEach((desc: TrainingDescription) => {
                if (desc.name === 'ZIELE1') {
                    this.learningGoalsText = desc.paragraphs;
                } else if (desc.name === 'TEILNEHMER') {
                    this.targetGroupText = desc.paragraphs;
                } else if (desc.name === 'INHALT') {
                    this.courseContentText = desc.paragraphs;
                    this.stylingForTitles(this.courseContentText);
                } else if (desc.name === 'HINWEIS') {
                    this.noteText = desc.paragraphs;
                } else if (desc.name === 'VORAUSSETZUNG') {
                    this.requirementsText = desc.paragraphs;
                }
            });
        }
    }

    public stylingForTitles(contentText) {
        contentText.forEach((paragraph: Paragraph) => {
            paragraph.text = paragraph.text.replace(':', '');
        });
        this.courseContentText = contentText;
    }
}
